export default {
  survey: [],
  surveyDetails: {},
  surveys: [],
  surveyTypes: [],
  incompleteSurveysCount: 0,
  buildingNote: []
}



// WEBPACK FOOTER //
// ./src/store/modules/survey/state.js